import React, { useState } from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { TableRules } from './components/TableRules';
import { FormRules } from './components/FormRules';
import { BannerInfoRules } from './components/BannerInfoRules';
import { FollowConfig } from './components/FollowConfig';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { alertInformativo } from '../../../commons/texts';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { mtDividerUpTable } from '../../../commons';
import { useResponseHandler } from '../../../hooks/useResponseHandler';

export const ReglasyAlertas = () => {
    const { handleResponse, ResponseComponents } = useResponseHandler();
    const [showForm, setShowForm] = useState(false);
    const [ruleToEdit, setRuleToEdit] = useState<any>(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleNew = () => {
        setRuleToEdit(null);
        setShowForm(true);
        // Scroll to form if needed
        setTimeout(() => {
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }, 100);
    };

    const handleEdit = (rule: any) => {
        setRuleToEdit(rule);
        setShowForm(true);
        setTimeout(() => {
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }, 100);
    };

    const handleCancel = () => {
        setShowForm(false);
        setRuleToEdit(null);
    };

    const handleSuccess = () => {
        setShowForm(false);
        setRuleToEdit(null);
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <Box sx={{ p: 3,  margin: '0 auto' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box>
                    <BreadCrumbsAndTitle
                        title="Reglas de Alertas" 
                        mainModule="calificaciones" 
                        parent="Configuraciones"
                        action="Reglas y Alertas" 
                        icon="Rule"
                    />
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.reglasyAlertas} /> 
                    </Typography>
                </Box>
                
                <Button 
                    variant="contained" 
                    startIcon={<AddIcon />} 
                    onClick={handleNew}
                    sx={{ 
                        bgcolor: '#4A148C', 
                        '&:hover': { bgcolor: '#380b6b' },
                        borderRadius: 1.5,
                        textTransform: 'none',
                        fontWeight: 700,
                        px: 3,
                        py: 1
                    }}
                >
                    Nueva Regla
                </Button>
            </Box>

            {ResponseComponents}

            <Divider sx={{ marginBottom: mtDividerUpTable }}/>
            <FollowConfig />
            
            <TableRules 
                onEdit={handleEdit} 
                refreshTrigger={refreshTrigger} 
            />

            {showForm && (
                <Box sx={{ mt: 4 }} id="form-rules-container">
                    <FormRules 
                        ruleData={ruleToEdit} 
                        onCancel={handleCancel} 
                        onSuccess={handleSuccess} 
                    />
                </Box>
            )}

            <BannerInfoRules />
        </Box>
    );
};